

































import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { getAppByAdmin } from '@/api/platform'
import PasswordModal from './components/passwordModal.vue'
import { InitModule } from '@/store/modules/init'

interface AppProps {
  id: number
  name: string
  url: string
  logo: string
  state: string
  createdAt: string
  updatedAt: string
  lastEditUser: string
}

@Component({
  name: 'Application',
  components: {
    PasswordModal
  }
})
export default class extends Vue {
  private isShowHeader = false
  private appList: AppProps[] = []
  private operationDialogFlag = false

  private async created() {
    // 获取有权限的应用
    const { content } = await getAppByAdmin < AppProps[] > (this.adminId)
    this.appList = content
    if (UserModule.token) {
      InitModule.GetShopList()
      InitModule.GetWarehouseList()
    }
  }

  get username() {
    return UserModule.userInfo.username
  }

  get adminId() {
    return UserModule.userInfo.adminId
  }

  private goApp(url: string, identification: string, id: number) {
    // 权限应用唯一标识
    if (identification === 'authority_platform') {
      this.$router.push('/authApp')
    } else {
      // window.open(`http://192.168.1.248:8081/home/welcome?token=${UserModule.token}&appId=${id}&adminId=${UserModule.userInfo.adminId}&username=${UserModule.userInfo.username}`,'_self')
      
      // window.open(`http://192.168.1.248:8081/#/home?token=${UserModule.token}&appId=${id}&adminId=${UserModule.userInfo.adminId}&username=${UserModule.userInfo.username}&superAdminFlag=${UserModule.superAdminFlag}&warehouse_id=${   JSON.stringify(UserModule.warehouse_id)}`,'_self')

      if(url.includes('pay')){
        window.open(`${url}?token=${UserModule.token}&appId=${id}&adminId=${UserModule.userInfo.adminId}&username=${UserModule.userInfo.username}`,'_self')
      }else if(url.includes('web.hoomi.cn')||url.includes('hr.hoomi.cn')||url.includes('sorting')){
        window.open(`${url}?token=${UserModule.token}&appId=${id}&adminId=${UserModule.userInfo.adminId}&username=${UserModule.userInfo.username}&superAdminFlag=${UserModule.superAdminFlag}&warehouse_id=${JSON.stringify(UserModule.warehouse_id)}`,'_self')
      }else{
        window.open(`${url}?token=${UserModule.token}&appId=${id}&adminId=${UserModule.userInfo.adminId}`,'_self')
      }
    }
  }

  private passwordUpdate() {
    this.operationDialogFlag = true
  }

  private async logout() {
    await UserModule.LogOut()
    this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }
}
